import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import rootReducer from './slices';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth', 'friends'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleWares) =>
        getDefaultMiddleWares({
            serializableCheck: false,
        }),
});

export default store;
export const persistor = persistStore(store);
